import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import * as queryString from 'query-string';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-course-payments',
  standalone: true,
  imports: [
    CommonModule, // for *ngIf, *ngFor, [ngStyle], etc.
    FormsModule, // for [(ngModel)]
  ],
  templateUrl: './course-payments.component.html',
  styleUrls: ['./course-payments.component.scss'],
})
export class CoursePaymentsComponent implements OnInit {
  paymentForm: UntypedFormGroup = null;
  payment: any = null;
  constructor(
    public formBuilder: UntypedFormBuilder,
    public commonService: CommonService,
    private apiListService: ApilistService
  ) {
    this.paymentForm = formBuilder.group({
      amount_1: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
      amount_2: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
      valdity_days: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
    });
  }

  ngOnInit(): void {
    this.getCoursePaymentSettings();
  }

  async getCoursePaymentSettings() {
    let service = this.apiListService.getApiConfigs('coursepaymenttype');
    this.payment = await this.commonService.invokeService(
      service[0].method,
      service[0].path,
      null
    );
    this.payment = this.payment?.data;
    // this.getPaymentDetails()
    this.paymentDetails = this.payment[0].payment_details;
    this.paymentDetails.map((item) => {
      item['paid_date'] = moment(item['paid_date']).format(
        'DD-MM-YYYY HH:mm:ss'
      );
    });

    this.tableColums = Object.keys(this.paymentDetails[0]);

    this.tableColums.splice(this.tableColums.indexOf('user_id'), 1);

    this.tableColums.splice(this.tableColums.indexOf('application_id'), 1);
    console.log(this.payment);
    this.payment = this.payment.map((item) => {
      item['edit'] = false;
      return item;
    });
  }
  paymentDetails: any = null;
  search: any = {
    user_contactnumber: '',
  };

  tableColums: string[] = null;
  async getPaymentDetails() {
    let service = this.apiListService.getApiConfigs('payment');

    this.paymentDetails = await this.commonService.invokeService(
      service[0].method,
      `${service[0].path}?${queryString.stringify(this.search)}`,
      null
    );

    this.paymentDetails = this.paymentDetails.data;
    console.log('this.paymentDetails ----->>', this.paymentDetails);

    this.paymentDetails.map((item) => {
      item['paid_date'] = moment(item['paid_date']).format(
        'DD-MM-YYYY HH:mm:ss'
      );
    });

    this.tableColums = Object.keys(this.paymentDetails[0]);

    this.tableColums.splice(this.tableColums.indexOf('user_id'), 1);

    this.tableColums.splice(this.tableColums.indexOf('application_id'), 1);
  }

  async updatePaymentSettings(p: any) {
    console.log('----- >>', p);
    let service = this.apiListService.getApiConfigs('updatepaymenttype');

    await this.commonService.invokeService(service[0].method, service[0].path, {
      id: p.type_id,
      admission_fees: p.amount_1,
      application_fees: p.amount_2,
      valdity_days: p.valdity_days,
    });

    this.getCoursePaymentSettings();
  }
}
